import { Component, OnInit } from '@angular/core';
import { LayoutService } from './service/app.layout.service';

@Component({
  selector: 'app-menu',
  templateUrl: './app.menu.component.html',
})
export class AppMenuComponent implements OnInit {
  model: any[] = [];

  constructor(public layoutService: LayoutService) {}

  ngOnInit() {
    this.model = [
      {
        label: 'Dashboard',
        permissions: ['dashboard_manager'],
        items: [
          {
            label: 'Riepilogo',
            icon: 'pi pi-fw pi-chart-line',
            permissions: ['dashboard_manager'],
            routerLink: ['/dashboard/summary'],
            routerLinkActiveOptions: { exact: false },
          },
          {
            label: 'Andamento',
            icon: 'pi pi-fw pi-building',
            permissions: ['dashboard_manager'],
            routerLink: ['/dashboard/trend'],
            routerLinkActiveOptions: { exact: false },
          },
          {
            label: 'Classifica',
            icon: 'pi pi-fw pi-list',
            permissions: ['dashboard_manager'],
            routerLink: ['/dashboard/score'],
            routerLinkActiveOptions: { exact: false },
          },
        ],
      },
      {
        label: 'Anagrafiche',
        permissions: ['contact_manager'],
        items: [
          {
            permissions: ['contact_manager'],
            label: 'Fisica',
            icon: 'pi pi-user',
            routerLink: ['/contacts/individual'],
            routerLinkActiveOptions: { exact: false },
          },
          {
            permissions: ['contact_manager'],
            label: 'Giuridica',
            icon: 'pi pi-building',
            routerLink: ['/contacts/company'],
            routerLinkActiveOptions: { exact: false },
          },
        ],
      },
      {
        label: 'Vendite/Locazioni',
        permissions: ['lead_manager', 'opportunity_manager'],

        items: [
          {
            label: 'Lead',
            icon: 'pi pi-dollar',
            permissions: ['lead_manager', 'opportunity_manager'],
            routerLink: ['/sales/leads'],
            routerLinkActiveOptions: { exact: false },
          },
          {
            label: 'Opportunità',
            permissions: ['lead_manager', 'opportunity_manager'],
            icon: 'pi pi-shopping-cart',
            routerLink: ['/sales/opportunities'],
            routerLinkActiveOptions: { exact: false },
          },
          {
            label: 'Adeguamento prezzi',
            permissions: ['lead_manager', 'opportunity_manager'],
            icon: 'pi pi-dollar',
            routerLink: ['/sales/price-adjustments'],
            routerLinkActiveOptions: { exact: false },
          },
          {
            label: 'Valutazione vendita',
            permissions: ['lead_manager', 'opportunity_manager'],
            icon: 'pi pi-shopping-cart',
            routerLink: ['/sales/selling-outcome'],
            routerLinkActiveOptions: { exact: false },
          },
        ],
      },
      {
        label: 'Acquisti/Affitti',
        permissions: ['lead_manager', 'purchase_manager'],
        items: [
          {
            label: 'Lead',
            permissions: ['lead_manager', 'purchase_manager'],
            icon: 'pi pi-dollar',
            routerLink: ['/purchases/leads'],
            routerLinkActiveOptions: { exact: false },
          },
          {
            label: 'Opportunità',
            icon: 'pi pi-shopping-cart',
            permissions: ['lead_manager', 'purchase_manager'],
            routerLink: ['/purchases/opportunities'],
            routerLinkActiveOptions: { exact: false },
          },
        ],
      },
      {
        label: 'Immobili',
        items: [
          {
            label: 'Lista',
            icon: 'pi pi-fw pi-building',
            routerLink: ['/properties'],
            routerLinkActiveOptions: { exact: false },
          },
        ],
      },
      {
        label: 'Appuntamenti',
        permissions: ['event_manager'],
        items: [
          {
            label: 'Lista',
            icon: 'pi pi-fw pi-list',
            permissions: ['event_manager'],
            routerLink: ['/appointments/list'],
            routerLinkActiveOptions: { exact: false },
          },
          {
            label: 'Calendario',
            permissions: ['event_manager'],
            icon: 'pi pi-fw pi-calendar',
            routerLink: ['/appointments/calendar'],
            routerLinkActiveOptions: { exact: false },
          },
        ],
      },
      {
        label: 'Commissioni',
        permissions: ['commission_manager'],
        items: [
          {
            label: 'Agenzia',
            icon: 'pi pi-fw pi-briefcase',
            routerLink: ['/fees/agency'],
            routerLinkActiveOptions: { exact: false },
          },
          {
            label: 'Network',
            icon: 'pi pi-fw pi-share-alt',
            routerLink: ['/fees/network'],
            routerLinkActiveOptions: { exact: false },
          },
          {
            label: 'Grafici',
            icon: 'pi pi-fw pi-chart-bar',
            routerLink: ['/fees/charts'],
            routerLinkActiveOptions: { exact: false },
          },
        ],
      },
      {
        label: 'Utenti',
        permissions: ['user_manager', 'can_read_users_list', 'is_back_office'],
        items: [
          {
            label: 'Lista',
            icon: 'pi pi-users',
            routerLink: ['/users'],
            routerLinkActiveOptions: { exact: false },
            permissions: ['user_manager', 'can_read_users_list', 'is_back_office'],
          },
          {
            label: 'Network',
            icon: 'pi pi-share-alt',
            permissions: ['network_manager', 'is_back_office'],
            routerLink: ['/network'],
            routerLinkActiveOptions: { exact: false },
          },
        ],
      },
      {
        label: 'Impostazioni',
        permissions: ['settings_manager'],
        items: [
          {
            label: 'Fonti',
            icon: 'pi pi-fw pi-cloud-download',
            routerLink: ['/sources'],
            permissions: ['settings_manager'],
            routerLinkActiveOptions: { exact: false },
          },
          {
            label: 'Sedi',
            icon: 'pi pi-fw pi-building',
            routerLink: ['/sites'],
            permissions: ['settings_manager'],
            routerLinkActiveOptions: { exact: false },
          },
          {
            label: 'Documenti',
            icon: 'pi pi-fw pi-copy',
            routerLink: ['/document-settings'],
            permissions: ['settings_manager'],
            routerLinkActiveOptions: { exact: false },
          },
          {
            label: 'Commissioni',
            icon: 'pi pi-percentage',
            routerLink: ['/fees-settings'],
            permissions: ['settings_manager'],
            routerLinkActiveOptions: { exact: false },
          },
        ],
      },
      {
        label: 'Configurazione',
        permissions: ['is_admin'],
        items: [
          {
            label: 'Branding',
            icon: 'pi pi-fw pi-palette',
            routerLink: ['/configurazione'],
            permissions: ['is_admin'],
            routerLinkActiveOptions: { exact: false },
          },
        ],
      },
    ];
  }
}
